<template>
  <div>
    <ul
      class="basics autoWidth"
    >
      <li
        v-for="offer in textids"
        :key="offer.id"
        v-b-tooltip.hover.noninteractive
        tabindex="0"
        :class="offer.class"
        :title="$t(offer.label+'.tooltip')"
      >
        <i :class="'icon color-' + offer.class">
          <icon-check /></i>
        <span :class="'text color-' + offer.class">{{ $t(offer.label+'.label') }}</span>
      </li>
    </ul>
  </div>
</template>
<script>
/** Icons */
import IconCheck from 'ICON:CheckCircle';
import config from 'config/appConfig';
/** Tooltip */
import { VBTooltip } from 'bootstrap-vue';
import 'scss/bootstrap/vue/components/tooltip.scss';

import offerDateCheck from 'mixins/offerDateCheck';
import { mapMutations } from 'vuex';

export default {
  name: 'InfoLabel',
  components: {
    IconCheck,
  },
  i18nOptions: { namespaces: 'offers' },
  directives: { 'b-tooltip': VBTooltip },
  mixins: [offerDateCheck],
  props: {
    objectData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      idPool: config.offerList.infolabel,
    };
  },

  computed: {
    offerIds() {
      return this.objectData.searchOffers;
    },
    objectNumber() {
      return this.objectData.objectNumber;
    },

    textids() {
      // filters the object by id and looks only for ids that are also in this.ids then checks which of the
      // objects in distinctions has the ignore key, and throws the ignored one out. splice used because only three badges should be displayed

      const startDate = this.$store.state.searchFilter?.startDate;
      return this.idPool
        .filter((el) => this.offerDateCheck(el, startDate)) // offers with dates
        .filter((el) => this.offerIds.includes(el.id)) // has object offer id
        .filter((el) => !this.idPool.map((el2) => el2.ignore).includes(el.id)) // should not be ignored
        .splice(0, 3); // give 3
    },
  },
  methods: {
    ...mapMutations({ cancelAble: 'SET_CANCELABEL' }),
  },
};
</script>
<style lang="scss" scoped>
  ul.basics {
    @include font_size_s;
    margin: 0.5em 0;
    padding: 0;

    li {
      list-style: none;
      margin: 0.15em 0;
      padding: 0;

      .icon {
        margin: 0 0.25em 0 0;
      }
    }
    &.autoWidth{
        li{
            display:inline-block;
        }
        .onrequest{
            color:$color_ci_complement;
        }
    }
  }
</style>
